import Vue from "vue";
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "G-ZGMSDP5ZV3" },
  appName: "Port Perry Pedals",
});
